import { useRef } from "react";
import {
  IconReceipt2,
  IconDownload,
  IconCircleCheck,
  IconClock,
  IconChevronLeft,
  IconChevronRight,
} from "@tabler/icons-react";
import styles from "../subscriptionPayment.module.css";
import Button from "../../../../components/UI/Button/button";
import moment from "moment";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import { fmtCurrency, getCurrencySymbol } from "../../../../utils/functions";

const PLAN_PILL_CLASS = {
  growth: "pillGrowth",
  quarterly: "pillQuarterly",
  basic: "pillBasic",
  starter: "pillStarter",
  pack: "pillPack",
  scale: "pillScale",
};

export default function PaymentHistoryCard({
  onDownloadAll,
  onDownloadRow,
  billingData,
  setPage,
  subscriptionData,
  fetchSubscription,
}) {
  const cardRef = useRef(null);

  return (
    <div className={styles.card} ref={cardRef}>
      <div className={`${styles.cardHeader} ${styles.historyCardHeader}`}>
        <div className={styles.cardHeaderLeft}>
          <div
            className={styles.cardIcon}
            style={{ background: "#fef3c7", color: "#d97706" }}
          >
            <IconReceipt2 size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Payment History</div>
            <div className={styles.cardSubtitle}>
              Your current payment history to date
            </div>
          </div>
        </div>
        {billingData?.length > 0 && (
          <Button
            variant="outline"
            size="sm"
            className={styles.btnDownloadAll}
            leftIcon={<IconDownload size={14} />}
            onClick={onDownloadAll}
          >
            Download all Invoice
          </Button>
        )}
      </div>

      <div className={styles.cardBody}>
        <div className={styles.historyListWrap}>
          <div className={styles.historyListHeader}>
            <div className={`${styles.historyListHcell} ${styles.hcolDate}`}>
              Billing Date
            </div>
            <div className={`${styles.historyListHcell} ${styles.hcolPlan}`}>
              Plan
            </div>
            <div className={`${styles.historyListHcell} ${styles.hcolAmount}`}>
              Amount
            </div>
            <div className={`${styles.historyListHcell} ${styles.hcolStatus}`}>
              Status
            </div>
            <div className={styles.hcolAction} />
          </div>

          {billingData?.map((r, i) => (
            <div className={styles.historyRow} key={r?._id}>
              <div className={styles.hcolDate}>
                {moment(r?.paymentDate).format("MMM Do, YYYY")}
              </div>
              <div className={styles.hcolPlan}>
                <span
                  className={`${styles.historyPlanPill} ${styles[PLAN_PILL_CLASS[r?.name]]}`}
                >
                  {r?.name}
                </span>
              </div>
              <div className={styles.hcolAmount}>
                {" "}
                {fmtCurrency(r?.price, r?.currency)}
              </div>
              <div className={styles.hcolStatus}>
                <span
                  className={`${styles.statusBadge} ${r?.paymentStatus?.toLowerCase() === "completed" ? styles.statusCompleted : styles.statusPending}`}
                >
                  {r?.paymentStatus?.toLowerCase() === "completed" ? (
                    <IconCircleCheck size={12} />
                  ) : (
                    <IconClock size={12} />
                  )}
                  {r?.paymentStatus}
                </span>
              </div>
              <div className={styles.hcolAction}>
                <button
                  className={styles.btnDownloadRow}
                  title="Download invoice"
                  onClick={onDownloadRow}
                >
                  <IconDownload size={15} />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.pagination}>
          <Pagination
            pageSize={10}
            onChange={(e) => {
              setPage(e);
              fetchSubscription(e);
            }}
            current={subscriptionData?.currentPage}
            total={subscriptionData?.totalItems}
            nextIcon={<IconChevronRight size={16} />}
            prevIcon={<IconChevronLeft size={16} />}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
}
